import * as React from 'react';

import HighlightWords from 'react-highlight-words';

import css from './highlighter.css';


type HighlighterProps = {
  className?: string;
  highlightClassName?: string;
  search?: string;
  searchWords?: string[];
  children?: string;
};

const Highlighter = ({
  search,
  searchWords,
  children,
  ...props
}: HighlighterProps) => (
  // @ts-expect-error - TS2786 - 'HighlightWords' cannot be used as a JSX component.
  <HighlightWords
    highlightTag="span"
    highlightClassName={css.highlight}
    // @ts-expect-error - TS2769 - No overload matches this call.
    searchWords={searchWords || [search]}
    textToHighlight={children || ''}
    autoEscape={true}
    {...props}
  />
);

export default Highlighter;
